if (!customElements.get('product-description')) {
  class ProductDescription extends HTMLElement {
    constructor() {
      super();
      this.pageType = document.querySelector('.product-info-tabs') ? 'separate-section' : 'general';
      this.swiperElement = this.querySelector('nav.pdp__navigator-container .container');
      this.links = this.querySelectorAll('nav .pdp__navigator-item');
      this.tabs = this.querySelectorAll('li.pdp__accordion-item');
      this.skuTableButton = this.querySelector('.sku-table__footer-button');
      this.categoryContainer = this.querySelector('.categories-container');
      this._onScroll = this.updateNavigator.bind(this);
      this._onNavClick = this._onNavClick.bind(this);
      this._tabToggleHandlers = [];
      this.init();
    }

    init() {
      this.initSwiper();
      if (this.categoryContainer) this.setupCategories();
      if (this.skuTableButton) this.setupSkuTable();
    }

    connectedCallback() {
      window.addEventListener('scroll', this._onScroll);
      this.links.forEach(link => link.addEventListener('click', this._onNavClick));
      this.tabs.forEach(tab => {
        const tabBtn = tab.querySelector('.pdp__accordion-toggle');
        if (tabBtn) {
          const handler = () => this.toggleTab(tab);
          tabBtn.addEventListener('click', handler);
          this._tabToggleHandlers.push({ tabBtn, handler });
        }
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      this.links.forEach(link => link.removeEventListener('click', this._onNavClick));
      this._tabToggleHandlers.forEach(({ tabBtn, handler }) => {
        tabBtn.removeEventListener('click', handler);
      });
      this._tabToggleHandlers = [];
    }

    initSwiper() {
      const settings = {
        centerInsufficientSlides: false,
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 0,
        freeMode: true
      };
      requirejs(['swiper'], Swiper => {
        this.swiper = new Swiper(this.swiperElement, settings);
      });
    }

    _onNavClick(e) {
      e.preventDefault();
      const target = e.currentTarget.getAttribute('data-target');
      const tab = this.querySelector(`#${target}`);
      if (!tab) return;
      const top = tab.getBoundingClientRect().top + window.scrollY - (this.swiperElement?.clientHeight || 0);
      window.scrollTo({ top, behavior: 'smooth' });
      const content = tab.querySelector('.pdp__accordion-body');
      tab.classList.add('is-open');
      if (content) {
        content.style.maxHeight = 'max-content';
        content.classList.remove('hidden');
      }
    }

    updateNavigator() {
      this.tabs.forEach((tab, tabIndex) => {
        const top = tab.getBoundingClientRect().top;
        const bottom = tab.getBoundingClientRect().bottom;
        if (top < (this.swiperElement?.clientHeight || 0) + 2 && bottom > 0) {
          const target = tab.getAttribute('id');
          this.links.forEach((link, index) => {
            if (link.getAttribute('data-target') === target) {
              link.classList.add('active');
              if (this.swiper && typeof this.swiper.slideTo === 'function') {
                this.swiper.slideTo(index);
              }
            } else {
              link.classList.remove('active');
            }
          });
        }
      });
    }

    toggleTab(tab) {
      if(this.pageType === 'general') return;
      const content = tab.querySelector('.pdp__accordion-body');
      const is_open = tab.classList.contains('is-open');
      if (!content) return;
      if (is_open) {
        tab.classList.remove('is-open');
        content.classList.add('hidden');
      } else {
        tab.classList.add('is-open');
        content.classList.remove('hidden');
        content.style.maxHeight = 'max-content';
      }
    }

    setupSkuTable() {
      const skuTable = this.querySelector('.sku-table');
      if (!skuTable) return;
      const skuRows = Array.from(skuTable.querySelectorAll('tbody tr'));
      this.skuTableButton.addEventListener('click', () => {
        const expanded = this.skuTableButton.dataset.expanded === 'true';
        this.skuTableButton.dataset.expanded = expanded ? 'false' : 'true';
        skuRows.forEach((row, idx) => {
          if (!expanded && idx > 2) {
            row.classList.add('hidden');
          } else {
            row.classList.remove('hidden');
          }
        });
      });
    }

    setupCategories() {
      requirejs(['swiper'], Swiper => {
        this.categorySwiper = new Swiper(this.categoryContainer, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true
        });
      });
    }
  }

  customElements.define('product-description', ProductDescription);
}